import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import RevealOnScroll from '../RevealOnScroll';

const CTASection = () => {
  return (
    <section className="section-padding bg-ep-primary relative overflow-hidden" data-testid="cta-section">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3"></div>
      
      <div className="container-custom relative z-10">
        <RevealOnScroll className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to simplify{' '}
            <span className="italic text-ep-secondary">estate administration?</span>
          </h2>
          <p className="text-lg text-white/80 mb-10 max-w-2xl mx-auto">
            Start managing your estate with clarity and confidence. 
            Begin your free trial today — no credit card required.
          </p>
          
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/register">
              <Button 
                className="bg-white text-ep-primary hover:bg-ep-subtle px-8 py-6 text-base font-medium group"
                data-testid="cta-primary-btn"
              >
                Create Estate for Free
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Link to="/pricing">
              <Button 
                variant="outline" 
                className="border-white/30 text-white hover:bg-white/10 px-8 py-6 text-base"
                data-testid="cta-secondary-btn"
              >
                View Pricing
              </Button>
            </Link>
          </div>
        </RevealOnScroll>
      </div>
    </section>
  );
};

export default CTASection;
